var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "29px",
    viewBox: "0 0 36 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "57F1A974-0E4F-4DED-AAF8-8C33CCF92B20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A74E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6FE6",
    offset: "31.4717061%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D69EA",
    offset: "66.8206292%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8358ED",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tweet-Icon",
    transform: "translate(-14.000000, -18.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1",
    transform: "translate(14.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0367213,28.478548 C24.2800568,28.478548 31.5222493,17.523077 31.5222493,8.0233642 C31.5222493,7.71205676 31.5159325,7.40215097 31.5017547,7.09392716 C32.9074632,6.07926953 34.1294218,4.8131551 35.0935127,3.37155354 C33.8034726,3.94370887 32.4150301,4.32944416 30.9587868,4.50338948 C32.4452106,3.61347909 33.5865943,2.20509674 34.1247894,0.526475414 C32.7332587,1.34994738 31.1930715,1.94901448 29.5530782,2.27139499 C28.2391745,0.874085708 26.3679846,1.40165441e-05 24.2974632,1.40165441e-05 C20.3209392,1.40165441e-05 17.0964004,3.21975437 17.0964004,7.18881916 C17.0964004,7.75312523 17.1597092,8.3015926 17.2832386,8.828054 C11.299502,8.52767946 5.9932119,5.66676264 2.44258356,1.31672817 C1.82367313,2.37890188 1.46740307,3.61347909 1.46740307,4.93019324 C1.46740307,7.42443727 2.73863302,9.62629619 4.67144719,10.9144166 C3.49047794,10.8781137 2.38081885,10.5540512 1.4104111,10.014975 C1.40886698,10.0449704 1.40886698,10.0751059 1.40886698,10.1066432 C1.40886698,13.5889134 3.89096591,16.4956643 7.18527072,17.1548624 C6.5805381,17.3191363 5.94422126,17.407861 5.28726939,17.407861 C4.82333222,17.407861 4.37216912,17.3618867 3.93378008,17.2780678 C4.85028409,20.1343591 7.50813168,22.2128725 10.6599566,22.2714616 C8.19512366,24.1998578 5.0908857,25.3489341 1.71755013,25.3489341 C1.13654078,25.3489341 0.563532754,25.3157148 -7.01871658e-05,25.2492764 C3.18656751,27.2884033 6.9699365,28.478548 11.0367213,28.478548"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6eb80124b1039cf9d294f264df75722e.svg";
export { ForwardRef as ReactComponent };